const routePath = {
  home: '/',
  blog: '/blog',
  search: '/search',
  music: '/music',
  archive: '/archive',
  blogDetail: '/p/',
  tag: '/t/',
  legal: '/legal',
  about: '/about',
  apps: '/apps',
  cv: '/cv',
  notFound: '/404',
};

export default routePath;